import { Suspense } from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import { DatabaseClient } from '@/features/database/ui/database-client';
import { useUser } from '@/shared/providers/user-context';
import { Spinner } from '@/shared/ui';

export function DatabasePage() {
  const { user } = useUser();
  const { masterId } = useParams<{ masterId: string }>();

  if (!user) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <Spinner size="sm" />
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>DB 관리 | 동구바이오제약</title>
      </Helmet>
      <Suspense
        fallback={
          <div className="w-full h-full flex items-center justify-center">
            <Spinner size="sm" />
          </div>
        }
      >
        <DatabaseClient
          masterId={masterId}
          user={user}
        />
      </Suspense>
    </>
  );
}
